module.exports = __webpack_public_path__ + "media/application/images/getapp-category-leaders-badge-e6602b10961588c534a5ef4ca10bf063.png";